import "./index.scss";

const QuantityPickerClassName = (quantity, maxQuantity, minQuantity) => {
  const maxQuantityClassName = `${"quantityBtn"} ${
    quantity < maxQuantity ? "" : "disabled"
  }`;
  const minQuantityClassName = `${"quantityBtn"} ${
    quantity > minQuantity ? "" : "disabled"
  }`;
  return maxQuantity ? maxQuantityClassName : minQuantityClassName;
};
const updateQuantity = (quantity, minQuantity, maxQuantity, setQuantity) => {
  if (quantity >= minQuantity && quantity <= maxQuantity) {
    return setQuantity(quantity);
  }
  return;
};
export { QuantityPickerClassName, updateQuantity };
